import script from "./OrdinaryClassesManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrdinaryClassesManager.vue?vue&type=script&setup=true&lang=ts"

import "./OrdinaryClassesManager.vue?vue&type=style&index=0&id=7c77e257&lang=css"

const __exports__ = script;

export default __exports__